/**
 * Auth gate. Unauthenticated users are redirected to /signin. Reads auth state
 * through src/auth/ only (MSAL/Entra) — at merge into andavo-dev this swaps to
 * the Auth0 gate with no change to the routed pages. Mirrors experts-web's
 * ProtectedRoute.
 */
import { Navigate, Outlet } from 'react-router';
import { isAuthenticated } from '@/auth/msal';

export function ProtectedRoute() {
  if (!isAuthenticated()) {
    return <Navigate replace to="/signin" />;
  }
  return <Outlet />;
}
